/**
 * 首页配图：static/home/1-2p/ 下素材；加载失败时回退 CDN。
 */
import { staticHome1_2pFile } from '@/utils/staticUrl';

const CDN = {
	hero: 'https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg',
	card: 'https://resources.xycoder.com/dowa/CompanyIntroduction-3.jpeg',
};

export const HOME_IMAGES = {
	hero: { local: staticHome1_2pFile('p1_Envi01.jpg'), fallback: CDN.hero },
	feature1: { local: staticHome1_2pFile('p1_Envi01.jpg'), fallback: CDN.card },
	feature2: { local: staticHome1_2pFile('p1_Nonte02.jpg'), fallback: CDN.card },
	feature3: { local: staticHome1_2pFile('DOWA儊僞僯僋僗-0130.jpg'), fallback: CDN.card },
	banner2: { local: staticHome1_2pFile('p1_僄儗僋僩儘僯僢僋.jpg'), fallback: CDN.hero },
};

export function homeImageList() {
	return Object.keys(HOME_IMAGES);
}



// WEBPACK FOOTER //
// ./src/config/homeAssets.js